import { createFileRoute } from '@tanstack/react-router'
import ProjectDetails from '../components/project-details/ProjectDetails'

export const Route = createFileRoute('/_a/projects/$projectId')({
  component: ProjectDetails,
})
